import { RemoteDeleteActivityValidation } from 'data/usecases';
import { DeleteActivityValidationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlDeleteActivityValidation } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeDeleteActivityValidation =
  (): DeleteActivityValidationUseCaseInterface =>
    new RemoteDeleteActivityValidation(
      makeApiUrlDeleteActivityValidation(),
      makeAxiosHttpClient(),
    );
